import React, { ChangeEvent, FC } from 'react';
import classNames from 'classnames';

import { LabelSize } from '../../types/Label';
import { Icon, IconSize } from '../Icon';
import withMouseDownCb, { PreventDefaultMouseDownProps } from '../withMouseDownCbHoc';

import styles from './Checkbox.module.scss';

export type CheckboxProps = {
  name: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
  labelSize?: LabelSize;
  'data-test'?: string;
};

const CheckboxWithoutDownCbHoc: FC<CheckboxProps & PreventDefaultMouseDownProps> = ({
  name,
  label,
  className,
  onChange,
  checked = false,
  disabled = false,
  labelSize = LabelSize.DEFAULT,
  onMouseDown,
  ...props
}) => {
  const classes = classNames(
    styles.root,
    {
      [styles.checked]: checked,
      [styles.disabled]: disabled,
      [styles.labelDefaultSize]: (labelSize === LabelSize.DEFAULT),
      [styles.labelLargeSize]: (labelSize === LabelSize.LARGE),
    },
    className,
  );

  return (
    <label className={classes}
           data-test={classNames(props['data-test'], 'checkbox-container')}
           onMouseDown={onMouseDown}>
      <input type="checkbox"
             data-test="checkbox-input"
             checked={checked}
             disabled={disabled}
             name={name}
             onChange={onChange}
             className={styles.input}
             {...props} />
      <span className={styles.wrapper}
            data-test="checkbox-wrapper" >
        {checked && (
          <Icon icon="check"
                className={styles.checkIcon}
                size={IconSize.SMALL} />
        )}
      </span>
      {label && (
        <span className={styles.labelText}
              data-test="checkbox-label">
          {label}
        </span>
      )}
    </label>
  );
};

export const Checkbox = withMouseDownCb(CheckboxWithoutDownCbHoc);
